import React from 'react'

const DataNotFound = ({name}) => {
  return (
    <div className='w-full text-left'>{name} not found.</div>
  )
}

export default DataNotFound